import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { KeyHighlights } from '../../molecules/key-highlights';
import { BQLink } from '../../atoms/bqlink';
import ArrowRightSmall from '../../atoms/icons/right-arrow';
import { isEmpty, get } from 'lodash';

import './key-highlights-full-widget.m.css';

const KeyHighlightsWidget = () => {
  const [storyData, setStoryData] = useState({});
  const [darkMode, setDarkMode] = useState(false);
  const queryClient = new QueryClient();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const storySlug = urlParams.get('slug');
    const dm = urlParams.get('dm');
    if (dm == 1) {
      setDarkMode(true);
    }

    const getStoryData = async () => {
      if (isEmpty(storyData)) {
        try {
          const response = await fetch(
            `https://www.ndtvprofit.com/api/v1/stories-by-slug?slug=${storySlug}`
          ).then((res) => res.json());
          setStoryData(response.story);
        } catch (e) {
          console.log('Error in api');
        }
      }
    };

    getStoryData();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
     <div styleName={`key-highlights-widget ${darkMode ? 'dark' : 'auto-dark'}`}>
        <KeyHighlights
          darkMode={darkMode}
          cards={storyData.cards}
          limit={3}
          budgetHeading={true}
          lbhref={`${get(storyData, 'url', '')}`}
          widget={true}
        />
        <div styleName="gradient"></div>
        <div className="mobile-only" styleName={`show-all-updates-key-highlights`}>
          <BQLink href={storyData.url} target="_blank">
            Show All Updates <ArrowRightSmall color={darkMode ? "white" : "sixth-color"} />
          </BQLink>
        </div>
      </div>
    </QueryClientProvider>
  );
};

export { KeyHighlightsWidget };
